import tagging from "./tagging-index";
import {
  LOGIN_SERVICE_APP_NAME,
  FORGOT_USERNAME_SERVICE_APP_NAME,
  FORGOT_PASSWORD_SERVICE_APP_NAME,
  REGISTRATION_SERVICE_APP_NAME
} from "./tagging-constants";

const execute = (func) => {
  try {
    func();
  } catch (e) {
    // Ignoring exceptions to avoid user interruption due to analytics activity
  }
};
let loginOTPFormEditEventFlag = false;
let registrationOTPFormEditEventFlag = false;
const TaggingHelper = {
  loginPasswordLandingEvent: () => {
    execute(() => {
      tagging.view({
        page_event: "view",
        page_name: "myvodacom: login: password",
        page_form_event: "started",
        page_form_name: "myvodacom: login password form",
        service_application_event: "start",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_step: "myvodacom: login with password",
        service_application_type: "transaction"
      });
    });
  },
  loginPasswordSuccessEvent: () => {
    execute(() =>
      tagging.view({
        page_form_event: "success",
        page_form_name: "myvodacom: login password form",
        service_application_event: "finish",
        service_application_step: "myvodacom: login with password: success",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_type: "transaction",
        page_event: "view",
        page_name: "myvodacom: login: password: success",
        visitor_login_type: "password"
      })
    );
  },
  loginOTPLandingEvent: () => {
    execute(() =>
      tagging.view({
        page_event: "view",
        service_application_event: "start",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_type: "transaction",
        page_name: "myvodacom: login: otp",
        service_application_step: "myvodacom: login with otp"
      })
    );
  },
  loginOTPFormEditEvent: () => {
    if (loginOTPFormEditEventFlag) {
      return;
    }
    loginOTPFormEditEventFlag = true;
    execute(() =>
      tagging.view({
        page_form_event: "started",
        page_form_name: "myvodacom: login form: otp",
        page_event: "view",
        service_application_step: "myvodacom: login: enter otp",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_type: "transaction",
        page_name: "myvodacom: login: enter otp"
      })
    );
  },
  loginOTPResentEvent: () => {
    execute(() =>
      tagging.view({
        page_form_event: "started",
        page_form_name: "myvodacom: login form: otp",
        page_event: "view",
        service_application_step: "myvodacom: login: resend otp",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_type: "transaction",
        page_name: "myvodacom: resend enter otp"
      })
    );
  },
  loginOTPSuccessEvent: () => {
    execute(() =>
      tagging.view({
        page_form_event: "success",
        page_form_name: "myvodacom: login form: otp",
        page_event: "view",
        service_application_event: "finish",
        service_application_name: LOGIN_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: login with otp: success",
        page_name: "myvodacom: login: otp: success",
        visitor_login_type: "LOGIN_OTP_SUCCESSS_EVENT"
      })
    );
  },
  loginApiErrorEvent: (message) => {
    TaggingHelper.genericApiErrorEvent("myvodacom: login: journey", message);
  },
  forgotUsernameLandingEvent: () => {
    execute(() =>
      tagging.view({
        page_event: "view",
        page_name: "myvodacom: forgot username",
        page_form_event: "started",
        page_form_name: "myvodacom: forgot username form",
        service_application_event: "start",
        service_application_name: FORGOT_USERNAME_SERVICE_APP_NAME,
        service_application_step:
          "myvodacom: forgot username: personal details",
        service_application_type: "transaction"
      })
    );
  },
  forgotUsernameRegisterClickEvent: () => {
    execute(() =>
      tagging.link({
        link_type: "o",
        link_name: "myvodacom: forgot username: register",
        link_url: ""
      })
    );
  },
  forgotUsernameSuccessEvent: () => {
    execute(() =>
      tagging.view({
        page_event: "view",
        service_application_event: "finish",
        service_application_name: FORGOT_USERNAME_SERVICE_APP_NAME,
        service_application_type: "transaction",
        page_name: "myvodacom: forgot username: success"
      })
    );
  },
  forgotUsernameErrorEvent: (message) => {
    TaggingHelper.genericApiErrorEvent(
      "myvodacom: forgot username: journey",
      message
    );
  },
  forgotPasswordLandingEvent: () => {
    execute(() =>
      tagging.view({
        service_application_event: "start",
        service_application_name: FORGOT_PASSWORD_SERVICE_APP_NAME,
        service_application_step: "myvodacom: forgot password: enter details",
        service_application_type: "transaction",
        page_name: "myvodacom: forgot password: enter details"
      })
    );
  },
  forgotPasswordOTPLandingEvent: () => {
    execute(() =>
      tagging.view({
        service_application_name: FORGOT_PASSWORD_SERVICE_APP_NAME,
        service_application_step: "myvodacom: forgot password: enter otp",
        service_application_type: "transaction",
        page_name: "myvodacom: forgot password: enter otp"
      })
    );
  },
  changePasswordLandingEvent: () => {
    execute(() =>
      tagging.view({
        service_application_name: FORGOT_PASSWORD_SERVICE_APP_NAME,
        service_application_step:
          "myvodacom: forgot password: create new password",
        service_application_type: "transaction",
        page_name: "myvodacom: forgot password: create new password"
      })
    );
  },
  changePasswordValidationEvent: () => {
    execute(() =>
      tagging.view({
        service_application_name: FORGOT_PASSWORD_SERVICE_APP_NAME,
        service_application_step:
          "myvodacom: forgot password: new password valid",
        service_application_type: "transaction",
        page_name: "myvodacom: forgot password: new password valid"
      })
    );
  },
  changePasswordSuccessEvent: () => {
    execute(() =>
      tagging.view({
        service_application_event: "finish",
        service_application_name: FORGOT_PASSWORD_SERVICE_APP_NAME,
        service_application_step:
          "myvodacom: forgot password: successfully changed",
        service_application_type: "transaction",
        page_name: "myvodacom: forgot password: successfully changed"
      })
    );
  },
  forgotPasswordErrorEvent: (message) => {
    TaggingHelper.genericApiErrorEvent(
      "myvodacom: forgot password journey",
      message
    );
  },
  createProfileLandingEvent: () => {
    execute(() =>
      tagging.view({
        page_name: "myvodacom: register: create an account",
        service_application_event: "start",
        service_application_name: REGISTRATION_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: register: create an account",
        page_form_event: "started",
        page_form_name: "myvodacom: registration form"
      })
    );
  },
  createPasswordLandingEvent: () => {
    execute(() =>
      tagging.view({
        page_name: "myvodacom: register: create a password",
        service_application_name: REGISTRATION_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: register: create a password",
        page_form_event: "success",
        page_form_name: "myvodacom: registration form"
      })
    );
  },
  registrationOTPLandingEvent: () => {
    execute(() =>
      tagging.view({
        page_name: "myvodacom: register: enter OTP",
        service_application_name: REGISTRATION_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: register: enter OTP"
      })
    );
  },
  registrationOTPFormEditEvent: () => {
    if (registrationOTPFormEditEventFlag) {
      return;
    }
    registrationOTPFormEditEventFlag = true;
    execute(() =>
      tagging.view({
        page_form_event: "started",
        page_form_name: "myvodacom: register: otp form"
      })
    );
  },
  registrationOTPResentEvent: () => {
    execute(() =>
      tagging.view({
        service_application_name: REGISTRATION_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: register: resend otp",
        page_name: "myvodacom: register: resend otp"
      })
    );
  },
  registrationOTPCaptureEvent: () => {
    execute(() =>
      tagging.view({
        page_form_event: "success",
        page_form_name: "myvodacom: register: otp form"
      })
    );
  },
  registrationSuccessEvent: () => {
    execute(() =>
      tagging.view({
        visitor_event: "registration",
        service_application_event: "finish",
        service_application_name: REGISTRATION_SERVICE_APP_NAME,
        service_application_type: "transaction",
        service_application_step: "myvodacom: register: success",
        page_name: "myvodacom: register: success"
      })
    );
  },
  registrationErrorEvent: (message) => {
    TaggingHelper.genericApiErrorEvent("myvodacom: register: journey", message);
  },
  genericApiErrorEvent: (journey, message) => {
    execute(() =>
      tagging.view({
        page_name: journey,
        page_form_event: "error",
        page_errors: message
      })
    );
  },
  resetLoginOTPCache: () => {
    loginOTPFormEditEventFlag = false;
  },
  resetRegistrationOTPCahce: () => {
    registrationOTPFormEditEventFlag = false;
  }
};

export default TaggingHelper;
